import { FC } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { XClose } from "untitledui-js-base";

interface SelectedOptionsBadgesProps {
  selectedOptions: string[];
  open: boolean;
  removeOption: (option: string) => void;
  getDisplayValue: (value: string) => string;
  setOpen: (open: boolean) => void;
}

export const SelectedOptionsBadges: FC<SelectedOptionsBadgesProps> = ({
  selectedOptions,
  open,
  removeOption,
  getDisplayValue,
  setOpen
}) => {
  return (
    <>
      {(open ? selectedOptions.slice(0, 99) : selectedOptions.slice(0, 3)).map(
        (option) => (
          <button
            key={option}
            onClick={(e) => {
              e.stopPropagation();
              removeOption(option);
            }}
          >
            <Badge
              variant={BadgeVariant.BASE}
              size={BadgeSize.SM}
              className="flex items-center gap-1 text-sm rounded-full py-1 px-2 cursor-pointer"
            >
              {getDisplayValue(option)}
              <XClose size="12" className="cursor-pointer stroke-[3px]" />
            </Badge>
          </button>
        )
      )}

      {!open && selectedOptions.length > 3 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }}
        >
          <Badge
            variant={BadgeVariant.BASE}
            size={BadgeSize.SM}
            className="text-sm rounded-full py-1 px-2 cursor-pointer"
          >
            +{selectedOptions.length - 3} more
          </Badge>
        </button>
      )}

      {open && selectedOptions.length > 99 && (
        <Badge
          variant={BadgeVariant.BASE}
          size={BadgeSize.SM}
          className="text-sm rounded-full py-1 px-2"
        >
          +{selectedOptions.length - 99} more
        </Badge>
      )}
    </>
  );
};
